import h from "@pipo-lib/axios";
import g from "qs";
import { Base64 as v } from "js-base64";
const P = "/payment/v1", Y = "/user/v1", z = "/agreement_deduct/v1", x = "/sku/v1", H = "/payout/v1", X = "/cashier/v1", Z = (e, a, t) => {
  const n = (s) => e(P + s), i = (s) => a(P + s), d = (s) => e(Y + s), o = (s) => e(z + s), p = (s) => e(x + s), _ = (s) => e(H + s), r = (s) => e(X + s), c = (s) => t.sign.signRequest(s).then((l) => {
    var y, f, A;
    const m = JSON.parse(
      (f = (y = l == null ? void 0 : l.data) == null ? void 0 : y.request) != null ? f : "{}"
    ), u = JSON.parse(
      (A = m == null ? void 0 : m.biz_content) != null ? A : "{}"
    );
    return u.__sign = m.sign, u.__requestTime = m.request_time, u;
  });
  return {
    payment: {
      storePaymentMethod: n(
        "/store_payment_method"
      ),
      authPaymentMethod: n(
        "/auth_payment_method"
      ),
      merchant_configs: n("/merchant_configs"),
      initiate_payment: (s) => c(s).then(n("/initiate_payment")),
      nonce: (s) => c(s).then(n("/nonce")),
      getPaymentDetails: n("/payment_details"),
      getBankCardRule: n(
        "/get_bank_card_rule"
      ),
      getPaymentMethods: n(
        "/payment_methods_v3"
      ),
      pay: n("/pay"),
      getListStoredMethods: n(
        "/list_stored_methods"
      ),
      getStoredMethodDetails: n(
        "/stored_method_details"
      ),
      savePrimaryPaymentMethod: n("/save_primary_payment_method"),
      deleteStoredMethod: n("/delete_stored_method"),
      get_bind_elements: n("/get_bind_elements"),
      initiate_subscription: n(
        "/initiate_subscription"
      ),
      query_params: i(
        "/query_params"
      ),
      getCashierBasicInfo: n("/cashier_basic_info"),
      validateApplepayMerchant: n("/validate_applepay_merchant"),
      getAgreementBasicInfo: n("/agreement_basic_info"),
      initiatePayment: (s) => c(s).then(n("/initiate_payment")),
      getBankcardInfoByOcr: n("/get_bankcard_info_by_ocr"),
      getUnifiedBinDetail: n("/get_unified_bin_detail"),
      getMandate: n("/get_mandate"),
      cancel: (s) => c(s).then(n("/cancel")),
      initiatePaymentAndPay: (s) => c(s).then(n("/initiate_payment_and_pay")),
      initiateSubscription: (s) => c(s).then(n("/initiate_subscription")),
      getSubscriptionBasicInfo: n("/subscription_basic_info"),
      setSubscriptionPI: n("/set_subscription_pi")
    },
    user: {
      feedbackQuitReason: d("/feedback"),
      getSceneLink: (s) => c(s).then(d("/get_scene_link"))
    },
    agreement: {
      bindAuthorizeAgreement: o(
        "/bind_authorize_agreement"
      ),
      bindCCDCAuthorizeAgreement: o(
        "/bind_ccdc_authorize_agreement_with_amount"
      ),
      initializeAgreement: (s) => c(s).then(o("/initialize_agreement")),
      agreementUnbindPaymentMethod: (s) => c(s).then(o("/agreement_unbind_payment_method")),
      cancelAgreement: (s) => c(s).then(o("/cancel_agreement")),
      queryAgreement: (s) => c(s).then(o("/query_agreement")),
      linkTokenToAgreement: (s) => c(s).then(o("/link_token_to_agreement"))
    },
    sku: {
      create: (s) => c(s).then(p("/create"))
    },
    payoutCashier: {
      getPIList: (s) => c(s).then(_("/cashier/get_pi_list")),
      getServiceFee: (s) => c(s).then(_("/cashier/query_exchange_rate")),
      getUserInfo: (s) => c(s).then(r("/user/info")),
      getCashierBasicInfo: _("/cashier/get_pi_basic_info"),
      SearchLN: r("/compliance/ln"),
      bindPI: r(
        "/pi/bind"
      ),
      unBind: r(
        "/pi/unbind"
      ),
      setPrimary: r("/pi/manage_default"),
      updatePI: r(
        "/pi/change"
      ),
      searchBanks: r("/search/banks"),
      queryOrder: r("/order/query"),
      createOrder: r("/order/create"),
      withdraw: r("/order/withdraw"),
      sendOtp: r(
        "/user/send_otp"
      ),
      checkOtpAndBind: r("/pi/check_otp_and_bind"),
      getCollectStatus: r("/pi/collect_status"),
      getValidDecision: r("/risk/query_validate_decision"),
      queryFX: r(
        "/order/exchange_rate"
      ),
      getFinancialCalendar: _("/cashier/query_financial_calendar"),
      getMicroVerify: _("/pi/verify_micro_amount"),
      validateHolderName: r("/name_check")
    }
  };
}, R = "/pipo", j = (e, a) => ({
  merchant: {
    getAllMerchant: e(R + "/get_merchant_ids")
  },
  sign: {
    signRequest: e(R + "/get_signed_request/v2")
  }
}), D = (e) => ({
  get_district: e("/administrative/district")
});
var E = Object.defineProperty, N = Object.getOwnPropertySymbols, q = Object.prototype.hasOwnProperty, V = Object.prototype.propertyIsEnumerable, O = (e, a, t) => a in e ? E(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, w = (e, a) => {
  for (var t in a || (a = {}))
    q.call(a, t) && O(e, t, a[t]);
  if (N)
    for (var t of N(a))
      V.call(a, t) && O(e, t, a[t]);
  return e;
};
class M {
  constructor(a) {
    this.BaseGet = (t, n = {}, i = {}) => this.axiosInstance.get(t, w({ params: n }, i)), this.Get = (t) => (n, i = {}) => this.BaseGet(t, n, i), this.BasePost = (t, n = {}, i = {}, d = {}) => this.axiosInstance.post(t, n, w({ params: i }, d)), this.Post = (t) => (n, i = {}, d = {}) => this.BasePost(t, n, i, d), this.axiosInstance = a;
  }
}
class I {
  constructor(a) {
    this.state = a, this.axiosInstance = h.create(), this.methods = new M(this.axiosInstance);
  }
}
const b = JSON.parse(
  v.decode(
    "eyJib2UiOiJodHRwczovL2YtcC1zYW5kYm94LmJ5dGVkYW5jZS5uZXQiLCJzZyI6Imh0dHBzOi8vZi1wLnNnc25zc2RrLmNvbSIsInZhIjoiaHR0cHM6Ly9mLXAtdmEuaXNuc3Nkay5jb20iLCJ0dHAiOiJodHRwczovL2ZwLnVzLnRpa3Rva3YuY29tIiwiaG9zdGVkLXBhZ2UiOiIvcGlwb19mZS9jaGVja291dC9wYXltZW50X2FwaSIsInNnLXN0cmVzcyI6Imh0dHBzOi8vZ2xvYmFsLXBheW1lbnQtc2cuc2dzbnNzZGsuY29tIiwiY2FzaGllci13aXRoZHJhdyI6Ii9waXBvX2ZlL2FwaS9jYXNoaWVyX25leHQvcHJveHkiLCJzYW5kYm94LWJvZSI6Imh0dHBzOi8vcGlwby1zYW5kYm94LWJvZS5ieXRlZGFuY2UubmV0Iiwic2FuZGJveCI6Imh0dHBzOi8vcGlwby1zYW5kYm94LmJ5dGVkLm9yZyJ9"
  )
), W = (e, a, t) => {
  var n;
  if (e.headers && !e.headers["Content-Type"] && (e.headers["Content-Type"] = "application/x-www-form-urlencoded"), e.headers && t === "sg-stress" && (e.headers["x-tt-stress"] = "payin_stress"), e.method === "post") {
    const i = e.data.__sign, d = (n = e.data.__requestTime) != null ? n : a.hasRequestTime ? new Date().toISOString() : "";
    delete e.data.__sign, delete e.data.__requestTime;
    const o = d, p = JSON.stringify(e.data), _ = {
      merchant_id: a == null ? void 0 : a.merchantId,
      sign: i,
      request_time: o,
      biz_content: p
    };
    _.sign || delete _.sign, e.data = g.stringify(_);
  }
  return e;
}, U = (e) => {
  try {
    if (e.config.method === "post") {
      const a = typeof e.data.response == "string" ? JSON.parse(e.data.response || "{}") : e.data.response;
      return a["x-tt-logid"] = e.headers["x-tt-logid"], a.__request = e.request, a;
    } else
      return e.data;
  } catch (a) {
    return Promise.reject(e);
  }
};
class F extends I {
  constructor(a) {
    super(a), this.setRequestInterceptors = () => {
      this.axiosInstance.interceptors.request.use(
        (t) => W(
          t,
          this.state,
          this.state.idc
        ),
        (t) => Promise.reject(t)
      );
    }, this.setResponseInterceptors = () => {
      this.axiosInstance.interceptors.response.use(
        (t) => U(t),
        (t) => Promise.reject(t)
      );
    }, this.setBaseURL = () => {
      this.axiosInstance.defaults.baseURL = this.domainName;
    }, this.setRequestInterceptors(), this.setResponseInterceptors(), this.setBaseURL();
  }
  get domainName() {
    return this.state.domainName || b[this.state.idc];
  }
}
const $ = "/pipo_fe/checkout", T = (e) => {
  let a = $;
  return e.idc !== "hosted-page" && (a = (b[e.idc] || "") + a), {
    configuration: {
      getPayinTCC: (t) => h.post(`${a}/api/tcc`, {
        key: t
      }),
      getConfigurablePaymentMethodId: (t, n, i) => h.post(
        `${a}/api/configurable_payment_method_id`,
        {
          version: t,
          merchant_id: n,
          merchant_user_id: i
        }
      )
    }
  };
}, Q = (e) => ({
  get_auto_complete: e("/address_oversea/place_autocomplete"),
  get_place_detail: e("address_oversea/place_detail")
}), K = JSON.parse(
  v.decode(
    "eyJib2UiOiJodHRwczovL3dwLWJvZS5ieXRlZGFuY2UubmV0Iiwic2ciOiJodHRwczovL3dwLXNnLXNlcnZlci5ieXRlZGFuY2UubmV0IiwidmEiOiJodHRwczovL3dwLmJ5dGVkYW5jZS5uZXQiLCJ0dHAiOiJodHRwczovL3BpcG8tbGl2ZS50aWt0b2stdXN0cy5uZXQiLCJob3N0ZWQtcGFnZSI6Imh0dHBzOi8vd3AtYm9lLmJ5dGVkYW5jZS5uZXQiLCJzZy1zdHJlc3MiOiJodHRwczovL2dsb2JhbC1wYXltZW50LXNnLnNnc25zc2RrLmNvbSIsInNhbmRib3gtYm9lIjoiaHR0cDovL3dwLXNhbmRib3gtYm9lLmJ5dGVkYW5jZS5uZXQiLCJzYW5kYm94IjoiaHR0cHM6Ly9waXBvLWxpdmUtc2FuZGJveC5ieXRlaW50bC5uZXQifQ"
  )
), ee = (e, a, t) => {
  if (e.headers && t === "sg-stress" && (e.headers["x-tt-stress"] = "payin_stress"), e.method === "post")
    if (e.url === "/pipo/get_merchant_ids")
      e.data = g.stringify(
        e.data || {
          type: 1
        }
      );
    else {
      const n = JSON.stringify(e.data), i = {
        merchant_id: a == null ? void 0 : a.merchantId,
        biz_content: n
      };
      e.data = g.stringify(i);
    }
  return e;
};
class te extends I {
  constructor(a) {
    super(a), this.setRequestInterceptors = () => {
      this.axiosInstance.interceptors.request.use(
        (t) => ee(
          t,
          this.state,
          this.state.idc
        ),
        (t) => Promise.reject(t)
      );
    }, this.setResponseInterceptors = () => {
      this.axiosInstance.interceptors.response.use(
        (t) => t.data.error_code ? Promise.reject(t) : t.data,
        (t) => Promise.reject(t)
      );
    }, this.setBaseURL = () => {
      this.axiosInstance.defaults.baseURL = this.domainName;
    }, this.setRequestInterceptors(), this.setResponseInterceptors(), this.setBaseURL();
  }
  get domainName() {
    return K[this.state.idc];
  }
}
const ae = JSON.parse(
  v.decode(
    "eyJib2UiOiJodHRwczovL2xvY2F0aW9uLXNnLmJ5dGVpbnRsLmNvbSIsInNnIjoiaHR0cHM6Ly9sb2NhdGlvbi1zZy5ieXRlaW50bC5jb20iLCJ2YSI6Imh0dHBzOi8vbG9jYXRpb24tdmEuYnl0ZWludGwuY29tIiwidHRwIjoiaHR0cHM6Ly9sb2NhdGlvbi51cy50aWt0b2suY29tIiwiaG9zdGVkLXBhZ2UiOiJodHRwczovL2xvY2F0aW9uLXNnLmJ5dGVpbnRsLmNvbSIsInNnLXN0cmVzcyI6Imh0dHBzOi8vbG9jYXRpb24tc2cuYnl0ZWludGwuY29tIiwiY2FzaGllci13aXRoZHJhdyI6Imh0dHBzOi8vbG9jYXRpb24tc2cuYnl0ZWludGwuY29tIiwic2FuZGJveC1ib2UiOiJodHRwczovL2xvY2F0aW9uLXNnLmJ5dGVpbnRsLmNvbSIsInNhbmRib3giOiJodHRwczovL2xvY2F0aW9uLXNnLmJ5dGVpbnRsLmNvbSJ9"
  )
);
class C extends I {
  constructor(a, t) {
    super(a), this.setResponseInterceptors = () => {
      this.axiosInstance.interceptors.response.use(
        (n) => {
          var i, d;
          const o = n.data;
          return !o || o.status !== "1" ? Promise.reject(n) : (d = (i = n.config) == null ? void 0 : i.params) != null && d.geonameid ? o.district.sub_region || [] : o.district || [];
        },
        (n) => Promise.reject(n)
      );
    }, this.setBaseURL = () => {
      this.axiosInstance.defaults.baseURL = this.domainName;
    }, t || this.setResponseInterceptors(), this.setBaseURL();
  }
  get domainName() {
    return this.state.locationDomain || ae[this.state.idc];
  }
}
class ne extends C {
  constructor(a) {
    super(a, !0), this.setResponseInterceptors = () => {
      this.axiosInstance.interceptors.response.use(
        (t) => {
          const n = t.data;
          return !n || n.status !== "1" ? Promise.reject(t) : n;
        },
        (t) => Promise.reject(t)
      );
    }, this.setResponseInterceptors();
  }
}
var se = Object.defineProperty, B = Object.getOwnPropertySymbols, ie = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable, k = (e, a, t) => a in e ? se(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, oe = (e, a) => {
  for (var t in a || (a = {}))
    ie.call(a, t) && k(e, t, a[t]);
  if (B)
    for (var t of B(a))
      re.call(a, t) && k(e, t, a[t]);
  return e;
};
const ce = (e) => {
  var a, t, n, i, d;
  const o = (n = (t = (a = e.elements) == null ? void 0 : a[0]) == null ? void 0 : t.option_list) == null ? void 0 : n.map((r) => r.value), p = ((i = e.elements) == null ? void 0 : i.map((r) => r.element)) || [], _ = ((d = e.marketing_events) == null ? void 0 : d.map((r) => r.starling_key)) || [];
  return {
    paymentMethodId: e.payment_method_id,
    elements: e.payment_method_type === "E_WALLET" ? p : o,
    model: e.model,
    unavailableCode: e.unavailable_code,
    unavailableMsg: e.unavailable_msg,
    fee_under_taker: e.fee_under_taker,
    payment_fee_amount: e.payment_fee_amount,
    quote_fee_amount: e.quote_fee_amount,
    defaultSelected: e.is_default,
    marketingEventText: _,
    card_type: e.card_type
  };
}, de = (e, a, t, n, i, d) => {
  var o;
  const {
    expiry_date: p,
    expiration_month: _,
    expiration_year: r,
    channel_pi_info: c = {}
  } = e, L = ((o = e.marketing_events) == null ? void 0 : o.map((l) => l.starling_key)) || [], s = i === "agreement" || i === "subscription" && d === "auto" ? { isAgreementBound: e.is_agreement_bound } : {};
  return oe({
    paymentMethodId: e.payment_method_id,
    title: e.masked_identity,
    token: e.payment_method_token,
    isPrimary: e.is_primary,
    expiryDate: p ? t(p) : _ && r ? `${_}/${r}` : void 0,
    balance: n({
      amount: c == null ? void 0 : c.balance_amount,
      currency: c == null ? void 0 : c.balance_currency,
      locale: a
    }),
    isExpired: e.is_expired,
    unavailableCode: e.unavailable_code,
    unavailableMsg: e.unavailable_msg,
    fee_under_taker: e.fee_under_taker,
    payment_fee_amount: e.payment_fee_amount,
    quote_fee_amount: e.quote_fee_amount,
    defaultSelected: e.is_default,
    marketingEventText: L
  }, s);
}, we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getFormatMethodsFromCashierBasicInfo: ce,
  getFormatStoredMethodsFromCashierBasicInfo: de
}, Symbol.toStringTag, { value: "Module" })), _e = "/pipo_fe/api/cashier_next", pe = (e) => {
  let a = _e;
  return e.idc !== "cashier-withdraw" && (a = (b[e.idc] || "") + a), {
    configuration: {
      getPayoutTCC: (t) => h.post(`${a}/tcc`, {
        key: t
      })
    }
  };
};
var le = /* @__PURE__ */ ((e) => (e.Direct = "direct", e.Redirect = "redirect", e))(le || {}), me = /* @__PURE__ */ ((e) => (e.COMGojekApp = "com.gojek.app", e.Empty = "", e.IDDanaSandbox = "id.dana.sandbox", e.OvoID = "ovo.id", e))(me || {}), he = /* @__PURE__ */ ((e) => (e.BankTransfer = "BANK_TRANSFER", e.Ccdc = "CCDC", e.Dcb = "DCB", e.EWallet = "E_WALLET", e))(he || {}), ue = /* @__PURE__ */ ((e) => (e.Empty = "", e.Gojek = "gojek://", e.Ovo = "ovo://", e))(ue || {}), ge = /* @__PURE__ */ ((e) => (e.None = "NONE", e.Notify = "NOTIFY", e.Reject = "REJECT", e))(ge || {}), ve = /* @__PURE__ */ ((e) => (e[e.VALID = 1] = "VALID", e[e.INVALID = 2] = "INVALID", e[e.VALIDATING = 5] = "VALIDATING", e[e.DISABLED = 6] = "DISABLED", e))(ve || {});
const Be = {
  PHONE: "phone",
  EMAIL: "email"
};
var Ie = /* @__PURE__ */ ((e) => (e[e.VALID = 1] = "VALID", e[e.INVALID = 2] = "INVALID", e[e.CANCELATION = 3] = "CANCELATION", e[e.EXPIRED = 4] = "EXPIRED", e[e.VALIDATING = 5] = "VALIDATING", e[e.DISABLED = 6] = "DISABLED", e))(Ie || {}), be = Object.defineProperty, J = Object.getOwnPropertySymbols, Le = Object.prototype.hasOwnProperty, ye = Object.prototype.propertyIsEnumerable, G = (e, a, t) => a in e ? be(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, S = (e, a) => {
  for (var t in a || (a = {}))
    Le.call(a, t) && G(e, t, a[t]);
  if (J)
    for (var t of J(a))
      ye.call(a, t) && G(e, t, a[t]);
  return e;
};
const fe = "/pipo_fe/checkout/common/land", Ae = "/pipo_fe/checkout/common/land/ovo", Pe = "/pipo_fe/checkout/common/land/gopay";
class ke {
  constructor(a) {
    this.api = { pipo: {}, woodpecker: {} }, this.pageLinks = {
      pollingPage: "",
      ovoPollingPage: "",
      gopayMiddlePage: ""
    }, this.initAPI = () => {
      const t = new te(this.state), n = j(
        t.methods.Post,
        t.methods.Get
      );
      this.api.woodpecker = n;
      const i = new F(this.state);
      this.api.pipo = Z(
        i.methods.Post,
        i.methods.Get,
        n
      ), this.api.checkout = T(this.state), this.api.cashier = pe(this.state);
      const d = new C(this.state);
      this.api.location = D(d.methods.Get);
      const o = new ne(this.state);
      this.api.addressAutocomplete = Q(
        o.methods.Get
      ), this.pageLinks = {
        pollingPage: i.domainName + fe,
        ovoPollingPage: i.domainName + Ae,
        gopayMiddlePage: i.domainName + Pe
      };
    }, this.state = a, this.initAPI();
  }
  updateState(a) {
    this.state = S(S({}, this.state), a), this.initAPI();
  }
}
export {
  le as IntegrationMethod,
  Be as OTPType,
  ge as PIFailureRiskRank,
  me as PackageName,
  he as PaymentMethodType,
  Ie as PayoutEwalletInstrumentStatusType,
  ve as PayoutInstrumentStatusType,
  ue as Schema,
  ke as default,
  we as utils
};
